import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {startLoadding, stopLoading} from '../../../Redux/FrontEnd/Loading/LoadingSlice'
import {ENV} from '../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const API_V2_URL = ENV().REACT_APP_API_V2_URL
const initialState: any = {
  messageApprovaldata: [],
}

export const getFirstMessageApprovalData: any = createAsyncThunk(
  '/getFirstMessageApprovalData',
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response: any = await axios.get(`${API_URL}admin/approval-sms/${data}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    response?.data?.result == 'Invalid Message' && toast?.error(response?.data?.resul)
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const FirstMessageApprovalResponse: any = createAsyncThunk(
  '/FirstMessageApprovalResponse',
  async (data: any, thunkApi) => {
    const response: any = await axios.put(`${API_V2_URL}admin/admin-approval/${data?.id}`, data.data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    if (response?.data?.status) toast?.success(response?.data?.message)
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

const FirstMessageApproval = createSlice({
  name: 'FirstMessageApproval',
  initialState,
  reducers: {},
  extraReducers: {
    ////////////////////////////superadmin///////////////////////////////////////////////////////////////////
    [getFirstMessageApprovalData.fulfilled]: (state, {payload}) => {
      return {...state, messageApprovaldata: payload.data}
    },
  },
})

export const GetMessageDetails = (state: any) =>
  state?.FirstMessageApprovalData?.messageApprovaldata

export default FirstMessageApproval.reducer
